<script>
  import { Backtop } from 'element-ui'
  export default {
    name:'ElBacktop',
    extends:Backtop
  }
</script>
